export enum ModuleState {
    DISABLED,
    READY,
    ARMED,
    DISARMED,
    FAILED
}